import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.parse-float.js";
export var formatValue = function formatValue(x) {
  if (x === null || x === undefined) return null;
  if (typeof x === 'boolean') return x;
  if (x === 'Missing') return x;
  return parseFloat(x).toFixed(1).replace(/\.?0+$/, '');
};